import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.View`
  width: ${RFValue(80)}px;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(40)}px;
  background-color: ${({theme}) => theme.colors.primary}15;
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(24)}px;
`;

export const IconStyled = styled(Feather)`
  font-size: ${RFValue(36)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const Title = styled.Text`
  font-size: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const Description = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(22)}px;
  margin-bottom: ${RFValue(32)}px;
  padding: 0 ${RFValue(12)}px;
`;

export const StepList = styled.View`
  width: 100%;
  margin-bottom: ${RFValue(32)}px;
`;

export const StepItem = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
  padding: 0 ${RFValue(8)}px;
`;

export const StepNumber = styled.View`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.primary};
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
`;

export const StepNumberText = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.buttonTitle};
`;

export const StepText = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text};
  flex: 1;
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px 24px ${RFValue(24)}px;
`;
